import { css } from '@linaria/core'
import { styled } from '@linaria/react'

import { Avatar } from 'components/designSystem/Avatar/Avatar'
import { RouterLink } from 'components/designSystem/Link/RouterLink'
import { breakpoints } from 'components/designSystem/shared/breakpoints'

export const defaultCss = css`
  color: var(--foreground-disabled);
`

export const activeCss = css`
  color: var(--foreground-default);
`

export const iconSizeCss = css`
  width: 32px;
  height: 32px;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    height: 24px;
    width: 24px;
  }
`

export const Parent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`

export const Link = styled(RouterLink)`
  display: flex;
  flex-grow: 1;
  position: relative;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  transition: color 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--foreground-default);
    }
  }
`

export const ChatLink = styled(Link)`
  display: none;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  min-height: 100%;

  @media screen and (max-width: ${breakpoints.startDesktop - 1}px) {
    display: flex;
  }
`

export const changeOrderCss = css`
  order: 1;
`

export const StyledAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  border-radius: 14px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${breakpoints.mobile + 1}px) {
    height: 24px;
    width: 24px;
    border-radius: 6px;
  }
`

export const activeAvatarCss = css`
  box-shadow: 0 0 0 2px var(--accent-primary-default);
`

export const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 64px;
  height: 48px;
`
